module.exports = __webpack_public_path__ + "img/pr-5.cc1183d0.png";